import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu-icons/logout.png'


const _withScopeId = n => (_pushScopeId("data-v-7d7d9956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "sidebar-container" }
const _hoisted_3 = { class: "sidebar-footer menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { class: "main" }
const _hoisted_6 = { class: "menu-page-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "logout-container",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.HandleLogout && $setup.HandleLogout(...args)))
        }, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.logout')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}